<template>
    <div class="device-type-add">
        <el-page-header @back="goBack" content="新增集团"></el-page-header>
        <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px" class="form"
                 :style="{width: form_width,margin: '20px auto 0 auto'}" autocomplete="off">
            <el-form-item label="集团全称" prop="bloc_name">
                <el-input type="text" v-model="ruleForm.bloc_name" placeholder="请输入集团全称" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="集团简称" prop="short_name">
                <el-input type="text" v-model="ruleForm.short_name" placeholder="请输入集团简称" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="集团分类" prop="catalog_id">
                <el-select :disabled="catalogDisabled" v-model="ruleForm.catalog_id" placeholder="请选择集团分类"
                           style="width: 100%;">
                    <el-option
                            v-for="item in allCatalog"
                            :key="item.id"
                            :label="item.catalog_name"
                            :value="item.id"
                    ></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="排序号" prop="sort">
                <el-input type="number" v-model="ruleForm.sort" placeholder="请输入排序号 (排序值越小越前)" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="负责人" prop="principal">
                <el-input type="text" v-model="ruleForm.principal" placeholder="请输入负责人" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="办公电话" prop="office_phone">
                <el-input type="text" v-model="ruleForm.office_phone" placeholder="请输入办公电话" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="联系地址" prop="address">
                <el-input type="text" v-model="ruleForm.address" placeholder="请输入联系地址" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="remark">
                <el-input type="text" v-model="ruleForm.remark" placeholder="请输入备注" autocomplete="off"
                          style="width: 100%;"></el-input>
            </el-form-item>
            <el-form-item label="状态" prop="status">
                <el-radio-group v-model="ruleForm.status">
                    <el-radio :label="1">启用</el-radio>
                    <el-radio :label="2">停用</el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item>
                <el-button @click="goBack">取消</el-button>
                <el-button type="success" @click="submitForm('ruleForm')">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
</template>
<script>
    import env from "@/api/env";
    import {getUserInfos} from '@/utils/userInfos';
    import {check} from "@/utils/checkData";
    import {isMobile} from "@/api/order";

    export default {
        created() {
            if (isMobile()) {
                this.form_width = "100%"
            }
            if (this.$route.params.catalog_id) {
                this.ruleForm.catalog_id = this.$route.params.catalog_id;
                this.catalogDisabled = true;
            }
        },
        mounted() {
            this.createParams();
        },
        data() {
            return {
                catalogDisabled: false,
                allCatalog: [],
                ruleForm: {
                    bloc_name: "",
                    short_name: "",
                    catalog_id: "",
                    sort: "10",
                    principal: "",
                    office_phone: "",
                    address: "",
                    remark: "",
                    status: 1,
                },
                rules: {
                    bloc_name: [
                        {required: true, message: "请输入集团全称", trigger: "blur"},
                    ],
                    short_name: [
                        {required: true, message: "请输入集团简称", trigger: "blur"},
                    ],
                    catalog_id: [
                        {required: true, message: "请选择分类", trigger: "blur"},
                    ],
                    sort: [
                        {required: true, message: "请输入排序号", trigger: "blur"},
                    ],
                    status: [
                        {required: true, message: "请选择状态", trigger: "blur"},
                    ],
                    principal: [
                        {required: true, message: "请输入负责人", trigger: "blur"},
                    ],
                    office_phone: [
                        
                        {required: true, pattern: /^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$|^((13[0-9])|(14[5|7])|(15([0-3]|[5-9]))|(18[0,5-9]))\d{8}$|^0\d{2,3}-?\d{7,8}$/, message: '请输入正确的电话号码或座机号码' }

                    ],
                    address: [
                        {required: true, message: "请输入联系地址", trigger: "blur"},
                    ],
                    // remark: [
                    //     {required: true, message: "请输入备注", trigger: "blur"},
                    // ],

                },
                is_submit: false,
                form_width: "40%",
            };
        },
        methods: {
            // 所有地区
            createParams() {
                let params = {
                    servername: 'Ruyi_AdminOperateServices',
                    method: 'getAllBlocCatalog',
                    params: {
                        status: 1
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    this.allCatalog = res.data.data;
                });
            },

            // 返回上一页
            goBack() {
                window.history.go(-1);
                // this.$router.push({
                //     name: "blocList",
                //     params: {}
                // });
                // window.close()
            },

            // 提交表单
            submitForm(formName) {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复提交',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                let _that = this
                this.$refs[formName].validate(valid => {
                    if (valid) {
                        let params = {
                            'servername': 'Ruyi_AdminOperateServices',
                            'method': 'createBloc',
                            'params': {
                                bloc_name: this.ruleForm.bloc_name,
                                short_name: this.ruleForm.short_name,
                                sort: this.ruleForm.sort,
                                status: this.ruleForm.status,
                                catalog_id: this.ruleForm.catalog_id,
                                principal: this.ruleForm.principal,
                                office_phone: this.ruleForm.office_phone,
                                address: this.ruleForm.address,
                                remark: this.ruleForm.remark,
                            }
                        };
                        this.$api.service(params).then(res => {
                            if (!check(res)) {
                                this.is_submit = true;
                                return;
                            }
                            this.$message({
                                type: "success",
                                message: '创建成功',
                                duration: 1500,
                                onClose: function () {
                                    // window.history.go(-1);
                                    _that.is_submit = true;
                                    _that.$router.push({
                                        name: "blocList",
                                        params: {}
                                    });
                                }
                            });
                        }).catch(()=>{
                            this.is_submit = false;
                        }).finally(() => {
                            this.is_submit = false;
                        });
                    } else {
                        this.$message({
                            type: "error",
                            message: '请输入必填项'
                        });
                        this.is_submit = true;
                        return false;
                    }
                });
            },
        }

    };
</script>
<style lang="scss">
    @import "@/styles/common.scss";


    .editor {
        line-height: normal !important;
        height: 800px;
    }

    .ql-snow .ql-tooltip[data-mode=link]::before {
        content: "请输入链接地址:";
    }

    .ql-snow .ql-tooltip.ql-editing a.ql-action::after {
        border-right: 0px;
        content: '保存';
        padding-right: 0px;
    }

    .ql-snow .ql-tooltip[data-mode=video]::before {
        content: "请输入视频地址:";
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item::before {
        content: '14px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=small]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=small]::before {
        content: '10px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=large]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=large]::before {
        content: '18px';
    }

    .ql-snow .ql-picker.ql-size .ql-picker-label[data-value=huge]::before,
    .ql-snow .ql-picker.ql-size .ql-picker-item[data-value=huge]::before {
        content: '32px';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item::before {
        content: '文本';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
        content: '标题1';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
        content: '标题2';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
        content: '标题3';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
        content: '标题4';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
        content: '标题5';
    }

    .ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
    .ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
        content: '标题6';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item::before {
        content: '标准字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=serif]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=serif]::before {
        content: '衬线字体';
    }

    .ql-snow .ql-picker.ql-font .ql-picker-label[data-value=monospace]::before,
    .ql-snow .ql-picker.ql-font .ql-picker-item[data-value=monospace]::before {
        content: '等宽字体';
    }
</style>
